export default __webpack_public_path__ + "static/media/noa-8.5dd0f7e4.jpg";